import React from 'react'
import BaseTextfield from './baseTextfield'
const SmallTextField = ({ ...props }) => {
  return (
    <BaseTextfield
      sx={{
        width: '100%',
        '& .MuiInputBase-colorWhite': {
          color: 'white!important'
        }
      }}
      size="small"
      color="default"
      {...props}
    />
  )
}

export default SmallTextField
